
import React, { ReactNode } from "react";
import Header from "./Header";
import PageObserver from "../Translation/PageObserver";

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="flex min-h-screen flex-col hero-dark-gradient">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 px-3 py-2 self-start m-2 rounded text-on-hero"
      >
        Hoppa till innehåll
      </a>
      <Header />
      <main id="main" className="flex-1">
        {children}
      </main>
      {/* PageObserver is now used inside MainLayout which is always within Router */}
      <PageObserver />
    </div>
  );
};

export default MainLayout;
